(function () {
  function getSourceSlides(root) {
    var source = root.querySelector('[data-gif-marquee-source]');
    if (!source) return [];

    if (source.content) {
      return Array.from(source.content.querySelectorAll('.ecko-gif-marquee__slide'));
    }

    return Array.from(source.querySelectorAll('.ecko-gif-marquee__slide'));
  }

  function hydrateImages(node) {
    node.querySelectorAll('img[data-ecko-src]').forEach(function (img) {
      var src = img.getAttribute('data-ecko-src');
      if (!src) return;
      img.setAttribute('src', src);
      img.removeAttribute('data-ecko-src');
      var srcset = img.getAttribute('data-ecko-srcset');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-ecko-srcset');
      }
    });
  }

  function cloneSlides(group, sourceSlides, minWidth) {
    group.innerHTML = '';
    var passes = 0;
    // Cap clones — 2 passes is enough for seamless scroll without exploding GIF weight
    while (group.getBoundingClientRect().width < minWidth && passes < 2) {
      sourceSlides.forEach(function (slide) {
        group.appendChild(slide.cloneNode(true));
      });
      passes += 1;
    }
    if (!group.children.length) {
      sourceSlides.forEach(function (slide) {
        group.appendChild(slide.cloneNode(true));
      });
    }
  }

  function initMarquee(root) {
    var track = root.querySelector('[data-gif-marquee-track]');
    if (!track) return;
    if (track.dataset.marqueeReady === 'true') return;

    var sourceSlides = getSourceSlides(root);
    if (!sourceSlides.length) return;

    // Hydrate GIF sources only when the marquee is actually activated
    sourceSlides.forEach(hydrateImages);

    var speed = parseFloat(root.dataset.speed) || 90;
    var viewportWidth = root.clientWidth || window.innerWidth;
    var minGroupWidth = Math.max(viewportWidth * 1.05, 320);

    track.innerHTML = '';

    var groupA = document.createElement('div');
    groupA.className = 'ecko-gif-marquee__group';
    cloneSlides(groupA, sourceSlides, minGroupWidth);
    hydrateImages(groupA);
    track.appendChild(groupA);

    var groupB = groupA.cloneNode(true);
    groupB.setAttribute('aria-hidden', 'true');
    track.appendChild(groupB);

    track.style.setProperty('--ecko-gif-marquee-duration', speed + 's');
    track.style.animation = 'ecko-gif-marquee-scroll ' + speed + 's linear infinite';
    root.classList.add('ecko-gif-marquee--ready');
    track.dataset.marqueeReady = 'true';
  }

  function resetMarquee(root) {
    var track = root.querySelector('[data-gif-marquee-track]');
    if (track) track.dataset.marqueeReady = 'false';
    initMarquee(root);
  }

  function observeAndInit(root) {
    if (root.dataset.eckoObserved === 'true') return;
    root.dataset.eckoObserved = 'true';

    var section = root.closest('[data-ecko-defer-section]') || root;

    function start() {
      initMarquee(root);
    }

    if (section.dataset.eckoDeferred === 'ready') {
      start();
      return;
    }

    section.addEventListener('ecko:defer-ready', start, { once: true });

    // Fallback if defer script isn't present
    if (!window.__eckoDeferMedia) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              start();
              io.disconnect();
            });
          },
          { rootMargin: '280px 0px' }
        );
        io.observe(root);
      } else {
        start();
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-gif-marquee]').forEach(observeAndInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(window.__eckoGifMarqueeResize);
    window.__eckoGifMarqueeResize = window.setTimeout(function () {
      document.querySelectorAll('[data-gif-marquee].ecko-gif-marquee--ready').forEach(resetMarquee);
    }, 250);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-gif-marquee]');
    if (root) {
      root.dataset.eckoObserved = 'false';
      observeAndInit(root);
    }
  });
})();
